import { Radio } from 'antd';
import React, { useState, useEffect } from 'react';
import './OverallProgressComponent.styles.scss';
import { Line } from '@ant-design/charts';
import moment from 'moment-timezone';

const OverallProgressComponent = ({ className }) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    asyncFetch();
  }, []);
  const asyncFetch = () => {
    // fetch('https://gw.alipayobjects.com/os/bmw-prod/55424a73-7cb8-4f79-b60d-3ab627ac5698.json')
    fetch('/data/charts/overallData.json')
      .then((response) => response.json())
      .then((json) => setData(json))
      .catch((error) => {
        console.log('fetch data failed', error);
      });
  };


  const config = {
    data: data,
    xField: 'year',
    yField: 'count',
    seriesField: 'name',
    smooth: true,
    // padding:'auto',
    autoFit: true,
    xAxis: {
      type: 'linear',
      label: {
        type: 'inner',
        formatter: function formatter (v) {
          return moment(v).year();
        },
      },
    },

    yAxis: {
      label: {
        formatter: function formatter (v) {
          return ''.concat(v).replace(/\d{1,3}(?=(\d{3})+$)/g, function (s) {
            return ''.concat(s, ',');
          });
        },
      },
    },
  };
  const onChange = (e) =>{
    console.log('e', e);
  };

  useEffect(() => {
    // asyncFetch();
  }, []);
  return (
    <div className={`${className}`}>
      <div className="common_card admin_stats_overall p-3 h-100">
        <div className="admin_stats_overall_top d-md-flex d-flex-wrap">
          <div className="col-md-5 p-0">
            <h4>Overall Progress</h4>
          </div>
          <div className="col-md-7 text-right p-0">
            <Radio.Group onChange={onChange}
              defaultValue="y"
              buttonStyle="solid">
              <Radio.Button value="w">Weekly</Radio.Button>
              <Radio.Button value="m">Monthly</Radio.Button>
              <Radio.Button value="y">Yearly</Radio.Button>
            </Radio.Group>
          </div>
        </div>
        <div className="chart_area pt-2">
          <Line {...config} />
        </div>
      </div>
    </div>
  );
};

export default OverallProgressComponent;
